import { Component, ElementRef, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { UserService } from '../services/user/user.service';
import { AuthService } from '../services/auth/auth.service';
import { Observable } from 'rxjs';
import { User } from '../models/user';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
})
export class MainComponent implements OnInit {
  get currentUser$(): Observable<User> {
    return this.userService.currentUser();
  }

  public isOwner(): Observable<boolean> {
    return this.userService.canManage();
  }

  public isAdmin(): Observable<boolean> {
    return this.userService.isAdmin();
  }

  public hasSetPassword(): Observable<boolean> {
    return this.userService.hasSetPassword();
  }

  // Set while support staff are signed in as this user through WorkOS impersonation
  get impersonator(): string | null {
    return this.authService.impersonator;
  }

  constructor(
    private userService: UserService,
    private authService: AuthService,
    private host: ElementRef<HTMLElement>,
  ) {}

  // A page that scrolls inside itself, as the AI chat does, has the frame made exactly as tall
  // as the window. Its route asks for this with `data: { fillWindow: true }`. Set on the element
  // directly: the first page arrives in the middle of a check, too late for a binding to change.
  onPageChange(outlet: RouterOutlet) {
    const fillsWindow = outlet.isActivated && !!outlet.activatedRouteData['fillWindow'];
    this.host.nativeElement.classList.toggle('main--fills-window', fillsWindow);
  }

  ngOnInit() {}
}
